export default __webpack_public_path__ + "static/media/gabriel-asencio-1.3ab1edac.webp";